module.exports = "../../app/cells/components/applied_exams_cell.rb";